// Bilingual dictionary (ID / EN) for NextStore.id
export const dict = {
  id: {
    nav: {
      work: "Karya",
      services: "Layanan",
      process: "Proses",
      pricing: "Paket",
      faq: "FAQ",
      cta: "Konsultasi Gratis",
    },
    hero: {
      eyebrow: "Studio Shopify · Jakarta · 2020",
      line1: "Toko Shopify",
      line1Italic: "yang siap",
      line2: "berjualan di",
      line2Italic: "Indonesia.",
      subline:
        "Kami membangun toko Shopify premium — lengkap dengan integrasi pengiriman lokal (JNE, J&T, SiCepat) dan pembayaran (Midtrans, Xendit, Duitku) — supaya brand Anda siap scale sejak hari pertama.",
      cta1: "Mulai Proyek Anda",
      cta2: "Lihat Karya Kami",
      stat1Value: "40+",
      stat1Label: "Toko diluncurkan",
      stat2Value: "6",
      stat2Label: "Tahun pengalaman",
      stat3Value: "12",
      stat3Label: "Kota di Indonesia",
    },
    trust: {
      label: "Terintegrasi dengan ekosistem lokal",
    },
    chapter01: {
      num: "01",
      overline: "Manifesto",
      title: "Kenapa Shopify?",
      body:
        "Shopify bukan sekadar platform — ini infrastruktur retail modern. Cepat, aman, dan fleksibel. Kami memilihnya karena kami tidak mau klien kami terkunci pada sistem yang menua lebih cepat dari brand mereka.",
      points: [
        {
          n: "→",
          t: "Skalabilitas Global",
          d: "Dari 10 order per hari sampai 10.000 — tanpa perlu ganti sistem.",
        },
        {
          n: "→",
          t: "Konversi Terukur",
          d: "Checkout Shopify dikenal punya conversion rate tertinggi di industri.",
        },
        {
          n: "→",
          t: "Ekosistem Aplikasi",
          d: "5.000+ apps siap plug-in — dari loyalty program sampai analytics.",
        },
      ],
    },
    chapter02: {
      num: "02",
      overline: "Karya Pilihan",
      title: "Case Study",
      subtitle: "Sebagian toko Shopify yang kami rancang untuk merchant lokal.",
    },
    chapter03: {
      num: "03",
      overline: "Metode",
      title: "Proses",
      subtitle: "Empat fase. Empat minggu. Toko yang siap tayang.",
      steps: [
        {
          n: "01",
          t: "Discovery",
          d: "Kami memahami brand, produk, dan target konsumen. Riset kompetitor & audience.",
        },
        {
          n: "02",
          t: "Design",
          d: "Wireframe → Visual desain custom. Bukan template. Fokus pada storytelling dan konversi.",
        },
        {
          n: "03",
          t: "Development",
          d: "Kustomisasi tema Shopify, integrasi Midtrans/Xendit, JNE/J&T/SiCepat/AnterAja, migrasi produk.",
        },
        {
          n: "04",
          t: "Launch & Support",
          d: "Training tim Anda, QA, launch, plus dukungan 30 hari pasca peluncuran.",
        },
      ],
    },
    chapter04: {
      num: "04",
      overline: "Investasi",
      title: "Paket",
      subtitle:
        "Semua paket sudah termasuk integrasi pengiriman & pembayaran Indonesia.",
      pkgs: [
        {
          tag: "Starter",
          name: "Basic",
          price: "5.000.000",
          for: "Untuk brand baru yang ingin online.",
          items: [
            "Setup Shopify + tema premium",
            "Kustomisasi hingga 8 halaman",
            "Integrasi 1 payment gateway",
            "Integrasi 2 kurir lokal",
            "Upload 50 produk pertama",
            "Training 1x (2 jam)",
          ],
        },
        {
          tag: "Paling Populer",
          name: "Growth",
          price: "12.000.000",
          for: "Untuk brand yang scaling.",
          items: [
            "Tema custom (bukan template)",
            "Kustomisasi hingga 15 halaman",
            "Integrasi Midtrans + Xendit",
            "Integrasi semua kurir (RajaOngkir)",
            "Upload hingga 200 produk",
            "SEO on-page + Meta pixel",
            "Training 2x + dukungan 30 hari",
          ],
        },
        {
          tag: "Full Service",
          name: "Enterprise",
          price: "25.000.000+",
          for: "Untuk brand established.",
          items: [
            "Custom theme dari nol",
            "Integrasi ERP / accounting",
            "Migrasi dari platform lain",
            "Custom app / API integration",
            "Multi-language & multi-currency",
            "Loyalty program setup",
            "Dukungan prioritas 90 hari",
          ],
        },
      ],
      ctaPkg: "Mulai dengan paket ini",
    },
    custom: {
      overline: "Layanan lain",
      title: "Butuh sesuatu di luar Shopify?",
      body:
        "Kami juga mengerjakan proyek web di luar ekosistem Shopify — mulai dari company profile sampai marketplace custom. Ceritakan idenya, kami rancang solusinya.",
      tags: [
        "Company Profile",
        "Landing Page Produk",
        "Sistem Booking",
        "Marketplace / Multi-vendor",
        "Learning Management",
        "Portfolio Profesional",
      ],
      cta: "Diskusikan Proyek",
    },
    testi: {
      overline: "Suara Klien",
      title: "Testimoni",
      items: [
        {
          quote:
            "NextStore.id benar-benar paham kebutuhan brand F&B kami. Toko selesai tepat waktu dan konversi kami naik 3x dalam 2 bulan pertama.",
          name: "Andina Prameswari",
          role: "Founder, Kopi Rimba",
        },
        {
          quote:
            "Integrasi Midtrans dan JNE-nya mulus. Kami tidak perlu pusing soal teknis — tinggal fokus jualan.",
          name: "Rio Hartono",
          role: "CEO, Serat Denim",
        },
        {
          quote:
            "Desainnya editorial, tidak template-y sama sekali. Toko kami terasa premium seperti brand internasional.",
          name: "Naya Ardiansyah",
          role: "Creative Director, Batik Nara",
        },
      ],
    },
    faq: {
      overline: "Pertanyaan Umum",
      title: "Yang sering ditanyakan",
      items: [
        {
          q: "Berapa lama proses pembuatan toko Shopify?",
          a: "Paket Basic biasanya selesai 2–3 minggu. Paket Growth 3–4 minggu. Enterprise 6–8 minggu tergantung kompleksitas.",
        },
        {
          q: "Apakah biaya sudah termasuk langganan Shopify?",
          a: "Belum. Biaya kami hanya untuk jasa desain, development, dan integrasi. Langganan Shopify dibayar langsung ke Shopify (mulai USD 39/bulan).",
        },
        {
          q: "Payment gateway apa saja yang didukung?",
          a: "Kami mengintegrasikan Midtrans, Xendit, Duitku, dan iPaymu. Semua metode pembayaran lokal (QRIS, VA, e-wallet, kartu kredit) tersedia.",
        },
        {
          q: "Bagaimana dengan integrasi kurir?",
          a: "Kami integrasikan JNE, J&T, SiCepat, AnterAja, Ninja Xpress, dan Pos Indonesia — via RajaOngkir atau API langsung kurir.",
        },
        {
          q: "Bisakah migrasi dari WooCommerce / Tokopedia?",
          a: "Bisa. Kami sudah menangani banyak migrasi dari WooCommerce, WordPress, dan platform lain. Termasuk migrasi produk, order history, dan customer database.",
        },
        {
          q: "Apakah tersedia dukungan setelah launch?",
          a: "Ya. Basic dapat 14 hari, Growth 30 hari, Enterprise 90 hari dukungan prioritas. Setelah itu, kami menyediakan retainer bulanan opsional.",
        },
      ],
    },
    cta: {
      overline: "Siap memulai?",
      line1: "Ayo bangun",
      line1Italic: "toko",
      line2: "berikutnya",
      line2Italic: "bersama.",
      body:
        "Konsultasi awal gratis. Kami akan mendengarkan dulu — baru menawarkan solusi.",
      button: "Chat via WhatsApp",
    },
    footer: {
      tagline: "Studio Shopify untuk merchant Indonesia.",
      based: "Dari Jakarta, untuk seluruh Nusantara.",
      col1: "Navigasi",
      col2: "Layanan",
      col3: "Kontak",
      rights: "Semua hak cipta dilindungi.",
    },
  },
  en: {
    nav: {
      work: "Work",
      services: "Services",
      process: "Process",
      pricing: "Pricing",
      faq: "FAQ",
      cta: "Free Consultation",
    },
    hero: {
      eyebrow: "Shopify Studio · Jakarta · Since 2020",
      line1: "Shopify stores",
      line1Italic: "made ready",
      line2: "for selling in",
      line2Italic: "Indonesia.",
      subline:
        "We craft premium Shopify storefronts — pre-wired with local shipping (JNE, J&T, SiCepat) and payments (Midtrans, Xendit, Duitku) — so your brand is ready to scale from day one.",
      cta1: "Start Your Project",
      cta2: "See Our Work",
      stat1Value: "40+",
      stat1Label: "Stores launched",
      stat2Value: "6",
      stat2Label: "Years in craft",
      stat3Value: "12",
      stat3Label: "Cities served",
    },
    trust: {
      label: "Wired into Indonesia's ecosystem",
    },
    chapter01: {
      num: "01",
      overline: "Manifesto",
      title: "Why Shopify?",
      body:
        "Shopify isn't just a platform — it's modern retail infrastructure. Fast, secure, and flexible. We chose it because we refuse to lock our clients into systems that age faster than their brands.",
      points: [
        {
          n: "→",
          t: "Global Scalability",
          d: "From 10 orders a day to 10,000 — no re-platform ever.",
        },
        {
          n: "→",
          t: "Measurable Conversion",
          d: "Shopify checkout consistently posts the industry's highest conversion.",
        },
        {
          n: "→",
          t: "App Ecosystem",
          d: "5,000+ apps ready to plug in — loyalty, analytics, subscriptions.",
        },
      ],
    },
    chapter02: {
      num: "02",
      overline: "Selected Work",
      title: "Case Studies",
      subtitle: "A few of the Shopify stores we've crafted for local merchants.",
    },
    chapter03: {
      num: "03",
      overline: "Method",
      title: "Process",
      subtitle: "Four phases. Four weeks. One store ready to launch.",
      steps: [
        {
          n: "01",
          t: "Discovery",
          d: "We map your brand, product, and audience. Competitor and market research included.",
        },
        {
          n: "02",
          t: "Design",
          d: "Wireframes → custom visual design. Never templated. Storytelling and conversion first.",
        },
        {
          n: "03",
          t: "Development",
          d: "Custom Shopify theme, Midtrans/Xendit integration, JNE/J&T/SiCepat/AnterAja, product migration.",
        },
        {
          n: "04",
          t: "Launch & Support",
          d: "Team training, QA, launch, and 30 days of hands-on post-launch support.",
        },
      ],
    },
    chapter04: {
      num: "04",
      overline: "Investment",
      title: "Packages",
      subtitle:
        "Every package includes local Indonesian shipping & payment integration.",
      pkgs: [
        {
          tag: "Starter",
          name: "Basic",
          price: "5,000,000",
          for: "For new brands going online.",
          items: [
            "Shopify setup + premium theme",
            "Up to 8 pages customized",
            "1 payment gateway integration",
            "2 local courier integrations",
            "First 50 products uploaded",
            "One 2-hour training session",
          ],
        },
        {
          tag: "Most Popular",
          name: "Growth",
          price: "12,000,000",
          for: "For brands ready to scale.",
          items: [
            "Custom theme (not templated)",
            "Up to 15 pages customized",
            "Midtrans + Xendit integration",
            "All couriers via RajaOngkir",
            "Up to 200 products",
            "On-page SEO + Meta pixel",
            "2 trainings + 30-day support",
          ],
        },
        {
          tag: "Full Service",
          name: "Enterprise",
          price: "25,000,000+",
          for: "For established brands.",
          items: [
            "Custom theme built from scratch",
            "ERP / accounting integration",
            "Migration from any platform",
            "Custom app / API integration",
            "Multi-language & multi-currency",
            "Loyalty program setup",
            "Priority support for 90 days",
          ],
        },
      ],
      ctaPkg: "Start with this package",
    },
    custom: {
      overline: "Other services",
      title: "Need something beyond Shopify?",
      body:
        "We also build web projects outside Shopify — from company profiles to fully custom marketplaces. Tell us the idea, we'll design the solution.",
      tags: [
        "Company Profile",
        "Product Landing Page",
        "Booking System",
        "Marketplace / Multi-vendor",
        "Learning Management",
        "Personal Portfolio",
      ],
      cta: "Discuss Your Project",
    },
    testi: {
      overline: "Client Voices",
      title: "Testimonials",
      items: [
        {
          quote:
            "NextStore.id truly understood our F&B brand. The store shipped on time and our conversion jumped 3x in the first two months.",
          name: "Andina Prameswari",
          role: "Founder, Kopi Rimba",
        },
        {
          quote:
            "The Midtrans and JNE integrations felt seamless. We could focus on selling, not on plumbing.",
          name: "Rio Hartono",
          role: "CEO, Serat Denim",
        },
        {
          quote:
            "The design feels editorial, never templated. Our store now looks and feels like an international brand.",
          name: "Naya Ardiansyah",
          role: "Creative Director, Batik Nara",
        },
      ],
    },
    faq: {
      overline: "Common Questions",
      title: "Frequently asked",
      items: [
        {
          q: "How long does it take to build a Shopify store?",
          a: "Basic usually ships in 2–3 weeks. Growth in 3–4 weeks. Enterprise 6–8 weeks depending on complexity.",
        },
        {
          q: "Does the price include a Shopify subscription?",
          a: "No. Our fees cover design, development, and integrations only. Shopify subscription (from USD 39/month) is paid directly to Shopify.",
        },
        {
          q: "Which payment gateways do you support?",
          a: "We integrate Midtrans, Xendit, Duitku, and iPaymu — covering QRIS, virtual accounts, e-wallets, and credit cards.",
        },
        {
          q: "What about courier integrations?",
          a: "JNE, J&T, SiCepat, AnterAja, Ninja Xpress, and Pos Indonesia — via RajaOngkir or direct courier APIs.",
        },
        {
          q: "Can you migrate from WooCommerce or Tokopedia?",
          a: "Yes. We've handled many migrations from WooCommerce, WordPress, and other platforms — including products, order history, and customer data.",
        },
        {
          q: "Is there post-launch support?",
          a: "Yes. Basic gets 14 days, Growth 30 days, Enterprise 90 days of priority support. Monthly retainers are available afterwards.",
        },
      ],
    },
    cta: {
      overline: "Ready to build?",
      line1: "Let's build",
      line1Italic: "your next",
      line2: "storefront",
      line2Italic: "together.",
      body:
        "Discovery call is free. We listen first — then propose a solution.",
      button: "Chat on WhatsApp",
    },
    footer: {
      tagline: "A Shopify studio for Indonesian merchants.",
      based: "From Jakarta, for all of Nusantara.",
      col1: "Navigate",
      col2: "Services",
      col3: "Contact",
      rights: "All rights reserved.",
    },
  },
};
